import type { StoreApi } from 'zustand'
import type { createBookingDetailsActions } from '../../domain/actions'
import type { BookingDetailsStore } from '../../domain/types'
import * as React from 'react'

interface BookingDetailsDependencies {
  actions?: ReturnType<typeof createBookingDetailsActions>
  store?: StoreApi<BookingDetailsStore>
}

const defaultDependencies: BookingDetailsDependencies = {}

const BookingDetailsDependenciesContext = React.createContext<BookingDetailsDependencies>(defaultDependencies)

export function BookingDetailsDependenciesProvider({
  children,
  dependencies = defaultDependencies,
}: React.PropsWithChildren<{ dependencies?: BookingDetailsDependencies }>) {
  return (
    <BookingDetailsDependenciesContext value={dependencies}>
      {children}
    </BookingDetailsDependenciesContext>
  )
}

export function useBookingDetailsDependencies() {
  return React.use(BookingDetailsDependenciesContext)
}

export function useBookingDetailsActions() {
  const { actions } = useBookingDetailsDependencies()
  if (!actions) {
    throw new Error('actions not provided')
  }
  return actions
}
